import { classNames } from 'primereact/utils';

import BASFLogoWhite from '../../assets/images/basf-logo-white.png';
import CircularTreeLogoWhite from '../../assets/images/circulartree-logo-white.png';
import PacificLogo from '../../assets/images/pacific-logo.svg';
import PacificLogoWhite from '../../assets/images/pacific-logo-white.png';
import styles from './index.module.css';

export enum LogoType {
  PACIFIC = 'pacific',
  CIRCULARTREE = 'circulartree',
  BASF = 'basf',
}

type LogoProps = {
  className?: string;
  type?: LogoType;
  white?: boolean;
  href?: string;
};

const logoSrcMap = {
  [LogoType.PACIFIC]: PacificLogo,
  [`${LogoType.PACIFIC}-white`]: PacificLogoWhite,
  [LogoType.CIRCULARTREE]: '',
  [`${LogoType.CIRCULARTREE}-white`]: CircularTreeLogoWhite,
  [LogoType.BASF]: '',
  [`${LogoType.BASF}-white`]: BASFLogoWhite,
};

const Logo = ({ className, type = LogoType.PACIFIC, white = false, href }: LogoProps) => {
  return (
    <a href={href} target='_blank' rel='noreferrer' className='h-full align-content-center'>
      <img
        src={logoSrcMap[`${type}${white ? '-white' : ''}`]}
        className={classNames(styles.logo, className)}
      />
    </a>
  );
};

export default Logo;
